module.exports = __webpack_public_path__ + "img/eq-stagbow.0037d9b6.png";